import { cx } from "shared/utils";

export const VerticalSpacer = ({
  height,
  className
}: {
  height: number;
  className?: string;
}) => {
  return (
    <div
      className={cx("w-px border-l border-dashed border-alpha-100", className)}
      style={{
        height
      }}
    />
  );
};
